import React from 'react';
import 'antd/dist/antd.css';
import ResponseFileBuilder from './Containers/ResponseFileBuilder/ResponseFileBuilder';
import TitleBar from './Components/TitleBar/TitleBar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { WINDOWS, LINUX } from './Utils/Constants';

function App() {
    return (
        <div>
            <TitleBar />
            <Router>
                <Switch>
                    <Route exact path='/'>
                        <ResponseFileBuilder useOs={WINDOWS} />
                    </Route>
                    <Route path='/windows'>
                        <ResponseFileBuilder useOs={WINDOWS} />
                    </Route>
                    <Route path='/linux'>
                        <ResponseFileBuilder useOs={LINUX} />
                    </Route>
                </Switch>
            </Router>
        </div>
    );
}

export default App;
